/**
 * Ensure all links not pointing to the shop itself are treated as exteran links and opened in a new tab/windo
 */
(function () {
  var SAME_HOST = 'store.karma-games.com';

  function isSkippable(href) {
    return !href ||
           href.startsWith('#') ||
           href.startsWith('mailto:') ||
           href.startsWith('tel:') ||
           href.startsWith('javascript:');
  }

  function ensureExternalAttrs(a) {
    var href = a.getAttribute('href');
    if (isSkippable(href)) return;

    var url;
    try { url = new URL(href, location.href); } catch (_) { return; }

    if (url.hostname !== SAME_HOST) {
      a.target = '_blank';
      // merge rel values without duplicates
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      ['noopener','noreferrer','external'].forEach(function(v){
        if (rel.indexOf(v) === -1) rel.push(v);
      });
      a.setAttribute('rel', rel.join(' '));
    }
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('a[href]') : []).forEach(ensureExternalAttrs);
  }

  // initial pass
  document.addEventListener('DOMContentLoaded', function(){ scan(document); });

  // handle dynamically injected content (apps/sections)
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(n){
        if (n.nodeType !== 1) return;
        if (n.tagName === 'A') ensureExternalAttrs(n);
        else scan(n);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // last-resort guard for links created right before click
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    ensureExternalAttrs(a);
  }, true);
})();